var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "currentColor",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.063A8.938 8.938 0 1 0 19.938 11 8.947 8.947 0 0 0 11 2.062Zm0 16.5A7.562 7.562 0 1 1 18.563 11 7.572 7.572 0 0 1 11 18.563Zm1.375-3.438a.687.687 0 0 1-.688.688 1.375 1.375 0 0 1-1.374-1.376V11a.687.687 0 1 1 0-1.375A1.375 1.375 0 0 1 11.687 11v3.438a.687.687 0 0 1 .688.687Zm-2.75-7.906a1.031 1.031 0 1 1 2.063 0 1.031 1.031 0 0 1-2.063 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoEditor);
export default __webpack_public_path__ + "static/media/info-editor.87f4b7e37dc75ecab7db638a841ce258.svg";
export { ForwardRef as ReactComponent };